// import "./polyfills";
const scanBtn = document.querySelector(".qr__btn");
const qrContainer = document.querySelector(".js-qr");
const qrLoadingBg = document.querySelector(".qr__loading--bg");
const qrLoadingIconMask = document.querySelector(".qr__loading--icon--mask");
const qrContent = document.querySelector(".qr__content");
const qrTitle = document.querySelector(".qr__content--title");
const pollItems = document.querySelectorAll(".qr__content--poll__item");
const multipleChoiceItems = document.querySelectorAll(
  ".qr__content--multiple-choice__item"
);
const audioPlayBtn = document.querySelector(".qr__content--audio__btn");
const selectedClass = "is-selected";
const contentPage = document.getElementById("content-page");
const homePage = document.getElementById("home-page");
const divBody = document.querySelector(".qr__content--body");
const bodyFeedback = document.querySelector(".qr__content--body__feedback");
const divPoll = document.querySelector(".qr__content--poll");
const pollFeedback = document.querySelector(".qr__content--poll__feedback");
const divMultipleChoice = document.querySelector(
  ".qr__content--multiple-choice"
);
const multipleChoiceFeedback = document.querySelector(
  ".qr__content--multiple-choice__feedback"
);
const divAudio = document.querySelector(".qr__content--audio");
const audioFeedback = document.querySelector(".qr__content--audio__feedback");
const submitBtn = document.querySelector(".js-submit-btn");
const contentBody = document.querySelector(".js-content-body");
const contentMultipleChoice = document.querySelector(
  ".js-content-multiple-choice"
);
const contentPoll = document.querySelector(".js-content-poll");
const contentAudio = document.querySelector(".js-content-audio");

const siteAppearance = window.SiteAppearance;

const transition = () => {
  qrContainer.classList.add("is-loading");

  setTimeout(() => {
    qrLoadingBg.classList.add("step-1");
    qrLoadingIconMask.classList.add("step-1");
  }, 2400);

  setTimeout(() => {
    qrLoadingBg.classList.remove("step-1");
    qrLoadingIconMask.classList.remove("step-1");
    qrLoadingBg.classList.add("step-2");
    qrLoadingIconMask.classList.add("step-2");
  }, 3600);

  setTimeout(() => {
    qrLoadingBg.classList.remove("step-2");
    qrLoadingIconMask.classList.remove("step-2");
    qrLoadingBg.classList.add("step-3");
    qrLoadingIconMask.classList.add("step-3");
  }, 4800);

  setTimeout(() => {
    qrContainer.classList.remove("is-loading");
    qrContainer.classList.add("is-scanned");
    cleanAnimations();
  }, 6000);
};

const cleanAnimations = () => {
  qrLoadingBg.classList.remove("step-3");
  qrLoadingIconMask.classList.remove("step-3");
};

const removeClasses = (items, className) => {
  items.forEach((item) => {
    if (item.classList.contains(`${className}`)) {
      item.classList.remove(`${className}`);
    }
  });
};

if (homePage) {
  scanBtn.addEventListener("click", (e) => {
    e.preventDefault();
    transition(); // will be removed after linking single.php to home.php
  });
}

//-------- GENERAL CONTENT PAGE
window.addEventListener("load", () => {
  if (contentPage) {
    contentPage.classList.add("is-loading");
    transition();
  }
});

//-------- SUBMIT ANSWER
const submitAnswerPoll = (postID, uniqueID, answer) => {
  const formData = new FormData();
  formData.append("action", "submit_poll_answers");
  formData.append("nonce", window.themeObj.nonce);

  formData.append("post_id", postID);
  formData.append("unique_id", uniqueID);
  formData.append("answer", answer);

  const url = window.themeObj.ajaxUrl;
  fetch(url, {
    method: "post",
    body: formData,
  })
    .then((response) => response.json())
    .then((res) => {
      if (!res.success) return;

      /* hide poll content and display the percentage of total poll answers */
      divPoll.classList.add("is-hidden");
      qrTitle.classList.add("is-hidden");
      setTimeout(() => {
        pollFeedback.classList.remove("display-none");
      }, 200);
      setTimeout(() => {
        divPoll.classList.add("display-none");
        qrTitle.classList.add("display-none");
        pollFeedback.classList.remove("display-none");
        pollFeedback.classList.add("is-open");
      }, 300);

      const answersCount = res.data.answers_count;
      const answerResult = document.querySelectorAll(".js-answer-item");
      answerResult.forEach((res) => {
        const answerTxt =
          res.getElementsByClassName("js-option-label")[0].innerText;
        const answerCount = answersCount[answerTxt];
        const answerBar = res
          .getElementsByClassName("bar")[0]
          .getElementsByClassName("js-bar")[0];
        const answerPercentage = res.getElementsByClassName("js-percent")[0];

        answerBar.style.width = answerCount.percentage + "%";
        answerPercentage.textContent = answerCount.percentage + "%";
      });
    });
};

const submitAnswerMc = (postID, uniqueID, answer, result) => {
  const formData = new FormData();
  formData.append("action", "submit_mc_answers");
  formData.append("nonce", window.themeObj.nonce);

  formData.append("post_id", postID);
  formData.append("unique_id", uniqueID);
  formData.append("answer", answer);
  formData.append("result", result);

  const url = window.themeObj.ajaxUrl;
  fetch(url, {
    method: "post",
    body: formData,
  })
    .then((response) => response.json())
    .then((res) => {
      // console.log(res);
      if (!res.success) return;

      divMultipleChoice.classList.add("is-hidden");
      qrTitle.classList.add("is-hidden");
      setTimeout(() => {
        multipleChoiceFeedback.classList.remove("display-none");
      }, 200);
      setTimeout(() => {
        divMultipleChoice.classList.add("display-none");
        qrTitle.classList.add("display-none");
        multipleChoiceFeedback.classList.remove("display-none");
        multipleChoiceFeedback.classList.add("is-open");
      }, 300);

      if (result == true) {
        let answerResult = document.querySelectorAll(".js-player-answer-true");
        let answerResultTitle = document.querySelector(
          ".js-player-answer-true"
        );
        let answerResultAnswer = answerResult[0].querySelector(".answer");
        answerResultAnswer.textContent = answer;
        answerResultTitle.style.display =
          answerResultTitle.style.display === "none" ? "" : "none";
      } else if (result == false) {
        let answerResult = document.querySelectorAll(".js-player-answer-false");
        let answerResultTitle = document.querySelector(
          ".js-player-answer-false"
        );
        let answerResultAnswer = answerResult[0].querySelector(".answer");
        answerResultAnswer.textContent = answer;
        answerResultTitle.style.display =
          answerResultTitle.style.display === "none" ? "" : "none";
      }
    });
};

const submitAnswerText = () => {
  divBody.classList.add("is-hidden");
  qrTitle.classList.add("is-hidden");
  setTimeout(() => {
    bodyFeedback.classList.remove("display-none");
  }, 200);
  setTimeout(() => {
    divBody.classList.add("display-none");
    qrTitle.classList.add("display-none");
    bodyFeedback.classList.remove("display-none");
    bodyFeedback.classList.add("is-open");
  }, 300);
};

const submitAnswerAudio = () => {
  divAudio.classList.add("is-hidden");
  qrTitle.classList.add("is-hidden");
  setTimeout(() => {
    audioFeedback.classList.remove("display-none");
  }, 200);
  setTimeout(() => {
    divAudio.classList.add("display-none");
    qrTitle.classList.add("display-none");
    audioFeedback.classList.remove("display-none");
    audioFeedback.classList.add("is-open");
  }, 300);
};

//-------- WYSIWYG CONTENT
if (divBody) {
  submitBtn.addEventListener("click", () => {
    const postID = qrContent.dataset.postId;
    const uniqueID = contentBody.dataset.uniqueId;

    submitAnswerText(postID, uniqueID);
  });
}

//-------- POLL CONTENT
if (divPoll) {
  pollItems.forEach((pollItem) => {
    pollItem.addEventListener("click", (e) => {
      removeClasses(pollItems, selectedClass);
      e.currentTarget.classList.toggle("is-selected");
      submitBtn.removeAttribute("disabled");
    });
  });

  /* submit user poll answer */
  submitBtn.addEventListener("click", () => {
    const postID = qrContent.dataset.postId;
    const uniqueID = contentPoll.dataset.uniqueId;
    const answer = document.querySelector(".js-answer-poll.is-selected");
    const answerTxt = answer.lastElementChild.innerText;

    submitAnswerPoll(postID, uniqueID, answerTxt);
  });
}

//-------- MULTIPLE CHOICE CONTENT
if (divMultipleChoice) {
  multipleChoiceItems.forEach((multipleChoiceItem) => {
    multipleChoiceItem.addEventListener("click", (e) => {
      removeClasses(multipleChoiceItems, selectedClass);
      e.currentTarget.classList.toggle("is-selected");
      submitBtn.removeAttribute("disabled");
    });
  });

  submitBtn.addEventListener("click", () => {
    const postID = qrContent.dataset.postId;
    const uniqueID = contentMultipleChoice.dataset.uniqueId;
    const answer = document.querySelector(".js-answer-mc.is-selected");
    let result = false;
    if (answer.classList.contains("is-true")) {
      result = true;
    }
    const answerTxt = answer.lastElementChild.innerText;

    submitAnswerMc(postID, uniqueID, answerTxt, result);
  });
}

//-------- AUDIO CONTENT
const audioEl = document.getElementById("test-audio"); // replace with dynamic ID

if (divAudio) {
  audioPlayBtn.addEventListener("click", handleAudioBtn, false);

  submitBtn.addEventListener("click", () => {
    const postID = qrContent.dataset.postId;
    const uniqueID = contentAudio.dataset.uniqueId;

    submitAnswerAudio(postID, uniqueID);
  });
}

async function playAudio() {
  try {
    await audioEl.play();
    audioPlayBtn.classList.add("is-playing");

    audioEl.onended = () => {
      audioPlayBtn.classList.remove("is-playing");
      submitBtn.removeAttribute("disabled");
    };
  } catch (err) {
    console.error(err);
    audioPlayBtn.classList.remove("is-playing");
  }
}

function handleAudioBtn() {
  if (audioEl.paused) {
    playAudio();
  } else {
    audioEl.pause();
    audioPlayBtn.classList.remove("is-playing");
  }
}

var heading_font_family =
  siteAppearance["typography"]["heading_font_family"].split(" | ");
var body_font_family =
  siteAppearance["typography"]["body_font_family"].split(" | ");

//-------- CUSTOMIZABLE CSS CONFIGURATION

// store parsed styling values from WP config (please name variables in camelCase convention)
const cssConfigs = [
  { primaryColor: siteAppearance["color_scheme"]["primary_color"] },
  { primaryColorLight: siteAppearance["color_scheme"]["primary_color_light"] },
  { primaryColorDark: siteAppearance["color_scheme"]["primary_color_dark"] },
  { secondaryColor: siteAppearance["color_scheme"]["secondary_color"] },
  { tertiaryColor: siteAppearance["color_scheme"]["tertiary_color"] },
  { textColor: siteAppearance["color_scheme"]["text_color"] },
  { textColorLight: siteAppearance["color_scheme"]["text_color_light"] },
  { redColor: siteAppearance["color_scheme"]["red_color"] },
  {
    headingFontFamily:
      '"' + heading_font_family[0] + '", ' + heading_font_family[1],
  },
  { headingFontSize: siteAppearance["typography"]["heading_font_size"] + "px" },
  { headingFontWeight: siteAppearance["typography"]["heading_font_weight"] },
  { bodyFontFamily: '"' + body_font_family[0] + '", ' + body_font_family[1] },
  { bodyFontSize: siteAppearance["typography"]["body_font_size"] + "px" },
  { bodyFontWeight: siteAppearance["typography"]["body_font_weight"] },
  { bodyLineHeight: siteAppearance["typography"]["body_line_height"] },
];

// separate keys and values of each style object into arrays
const cssConfigKeys = cssConfigs.flatMap(Object.keys);
const cssConfigVals = cssConfigs.flatMap(Object.values);

// loop over one of the arrays (since both should be the same size)
cssConfigKeys.forEach((config, idx) => {
  // store serialized key string in this variable (converting camelCase keys into kebab-case)
  const serializedVar = config
    .split(/(?=[A-Z])/)
    .join("-")
    .toLowerCase();

  // set each global CSS variable to its corresponding value (naming convention: --example-var)
  document.documentElement.style.setProperty(
    `--${serializedVar}`,
    cssConfigVals[idx]
  );
});
